import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { CoreMenuService } from '@core/components/core-menu/core-menu.service';
import { Observable } from 'rxjs';
import { Role } from '../models/role';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {

    // const bypassUrls = ['download-apk']; // match your routing path here

    // if (bypassUrls.includes(route.routeConfig?.path || '')) {
    //   return true;
    // }

    const currentUser = this.auth?.currentUserValue;
    const isAuthenticated = this.auth?.isAuthenticated;
    console.log('currreeennntt',this.auth?.currentUserValue)

    if (currentUser && isAuthenticated) {
      const requiredRoles = route.data.roles;
      if (requiredRoles && !requiredRoles.includes(currentUser.roles[0])) {
        this.router.navigate(['/error/unauthorized']);
        return false;
      }

      return true;
    }
    
    this.auth.clearSession();
    this.router.navigate(['/auth/login']);
    return false;
  }
  
}
